import * as React from "react";

function SvgOsano(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 600 600"
      {...{ ...props, ref }}
    >
      <path d="m0 0h600v600h-600z" fill="none" />
      <path
        d="m300 183.06a116.94 116.94 0 1 0 116.94 116.94 117.07 117.07 0 0 0 -116.94-116.94m0-120.56c131.17 0 237.5 106.33 237.5 237.5s-106.33 237.5-237.5 237.5-237.5-106.33-237.5-237.5 106.33-237.5 237.5-237.5z"
        fill="#7764fa"
      />
    </svg>
  );
}

export default React.forwardRef(SvgOsano);
